<template>
  <b-card no-body class="border-top-0 border-left-0 border-right-0 rounded-0">
    <b-card-header header-tag="header" class="p-0 border-0 rounded-0 bg-transparent" role="tab">
      <b-button
        v-b-toggle="isOpen ? undefined : segment.segmentId"
        variant="ghost"
        class="w-100 d-flex gap-5px"
        @click="onOpen"
      >
        <span
          v-html="check_mark(everyoneSeated ? color_success : '#adb5bd', 14)"
          :style="{ 'margin-top': '-1px' }"
        ></span>
        <span :class="'flex-grow text-left ' + (isOpen ? 'bold' : '')">{{
          formatSegmentLabel(segment)
        }}</span>
        <span
          v-html="svgSelectorCaret()"
          :style="{ transform: 'rotate(' + (isOpen ? 180 : 0) + 'deg)' }"
        ></span>
      </b-button>
    </b-card-header>
    <b-collapse :id="segment.segmentId" :visible="isOpen" role="tabpanel">
      <b-card-body class="pt-1">
        <div class="d-none d-lg-flex d-xl-flex flex-column gap-5px">
          <slot name="flight"></slot>
          <slot name="deck"></slot>
          <slot name="passengers"></slot>
        </div>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import { formatSegmentLabel } from '@/utilities';
import { check_mark } from '@/components/svg';
import { svgSelectorCaret } from '../../svg/seat-map';
import { color_success } from '@/resources/colors';

export default {
  name: 'seat-navigation-accordion-block',
  props: {
    segment: Object,
    everyoneSeated: Boolean,
    isOpen: Boolean,
    onOpen: Function,
  },
  data() {
    return {
      color_success,
    };
  },
  methods: {
    formatSegmentLabel,
    check_mark,
    svgSelectorCaret,
  },
};
</script>

<style lang="scss"></style>
